import { gql } from "@apollo/client";

export const get_total_product_stock_items_count = gql`
  query _count($where: ProductStockItemWhereInput) {
    aggregateProductStockItem(where: $where) {
      _count {
        id
      }
    }
  }
`;

export const get_total_stock_history_count = gql`
  query _count($where: StockHistoryWhereInput) {
    aggregateStockHistory(where: $where) {
      _count {
        id
      }
    }
  }
`;

export const GET_STOCK_HISTORIES = gql`
  query StockHistories(
    $where: StockHistoryWhereInput
    $orderBy: [StockHistoryOrderByWithRelationInput!]
    $take: Float
    $skip: Float
  ) {
    stockHistories(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
      id
      qty
      closing_qty
      stock_date
      transaction_type
      description
      ref_id
      ref_type
      ref_detail_id
      stock_id
      created_at
      stock {
        id
        name
        product {
          id
          name
        }
      }
    }
  }
`;

export const getStockHistoryVariables = (params: {
  clinic_id: string;
  from_date: string;
  to_date: string;
  take?: number;
  skip?: number;
  searchText?: string;
  refTypes?: string[];
}) => {
  const {
    clinic_id,
    from_date,
    to_date,
    take = 50,
    skip = 0,
    refTypes = [],
  } = params;
  let variables: any = {};
  let where: any = {
    clinic_id: {
      equals: clinic_id,
    },
    stock_date: {
      gte: from_date,
      lte: to_date,
    },
  };
  const orderBy = [
    {
      stock_date: "desc",
    },
    {
      cumulative_seq: "desc",
    },
  ];
  if (refTypes.length > 0) {
    where.ref_type = {
      in: refTypes,
    };
  }
  if (params.searchText && params.searchText.trim().length > 0) {
    where.OR = [
      {
        stock: {
          is: {
            name: {
              contains: params.searchText,
            },
          },
        },
      },
    ];
  }
  variables.where = where;
  variables.orderBy = orderBy;
  variables.take = take;
  variables.skip = skip;
  return { variables, where };
};
export const GENERATE_INVENTORY_REPORT = gql`
  query GenerateInventoryReport(
    $where: ProductStockItemWhereInput!
    $take: Int!
    $skip: Int!
    $toDate: DateTime!
  ) {
    generateInventoryReport(
      where: $where
      take: $take
      skip: $skip
      toDate: $toDate
    ) {
      id
      name
      current_qty
      received_qty
      sale_qty
      adjustment_in_qty
      adjustment_out_qty
    }
  }
`;

export const getGenerateInventoryReportVariables = (params: {
  clinicId: string;
  take?: number;
  skip?: number;
  searchText?: string;
  toDate: Date;
}) => {
  const { clinicId, take = 50, skip = 0, searchText, toDate } = params;
  let variables: any = {};
  let where: any = {
    clinic_id: {
      equals: clinicId,
    },
  };
  if (params.searchText && params.searchText.trim().length > 0) {
    where.OR = [
      {
        name: { contains: searchText },
      },
    ];
  }
  variables.where = where;
  variables.take = take;
  variables.skip = skip;
  variables.toDate = toDate;
  return { variables, where };
};

export const GENERATE_STOCK_SUMMARY = gql`
  query GenerateStockSummaryReport(
    $where: ProductStockItemWhereInput!
    $take: Int!
    $skip: Int!
    $fromDate: DateTime!
    $toDate: DateTime!
  ) {
    generateStockSummaryReport(
      where: $where
      take: $take
      skip: $skip
      fromDate: $fromDate
      toDate: $toDate
    ) {
      id
      name
      opening_qty
      in_qty
      out_qty
      closing_qty
    }
  }
`;

export const getGenerateStockSummaryVariables = (params: {
  clinicId: string;
  take?: number;
  skip?: number;
  searchText?: string;
  toDate: Date;
  fromDate: Date;
}) => {
  const {
    clinicId,
    take = 50,
    skip = 0,
    searchText,
    toDate,
    fromDate,
  } = params;
  let variables: any = {};
  let where: any = {
    clinic_id: {
      equals: clinicId,
    },
  };
  if (searchText && searchText.trim().length > 0) {
    where.OR = [
      {
        name: { contains: searchText },
      },
    ];
  }
  variables.where = where;
  variables.take = take;
  variables.skip = skip;
  variables.fromDate = fromDate;
  variables.toDate = toDate;
  return { variables, where };
};
